var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "capusta-title"
  }, [_c('div', {
    staticClass: "title-navigation",
    class: {
      'outside': _vm.iconOutside
    }
  }, [_c('a', {
    staticClass: "title-navigation-link",
    attrs: {
      "title": _vm.$t('common.back')
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.goTo($event);
      }
    }
  })]), _vm.title ? _c('div', {
    staticClass: "title-container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._t("default")], 2) : _vm._e(), _c('div', {
    staticClass: "description-container"
  }, [_vm._t("description")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }